import { useTranslation } from "react-i18next";
import { ButtonLink } from "@/shared/ui/Button";
import { PageHeader } from "@/shared/ui/PageHeader";
import { useDocumentTitle } from "@/shared/lib/useDocumentTitle";

export function NotFoundPage() {
  const { t } = useTranslation();
  useDocumentTitle(t("notFound.title"));
  return (
    <div>
      <PageHeader eyebrow="404" title={t("notFound.heading")} lead={t("notFound.lead")} />
      <ButtonLink to="/">{t("notFound.back")}</ButtonLink>
    </div>
  );
}
